import "../models/location.js";
import "#/shared/api/api-host-global.js";

window.Sparkle ??= {};
window.Sparkle.LocationBrowser ??= {};
window.Sparkle.LocationBrowser.Collections ??= {};

Sparkle.LocationBrowser.Collections.Locations = class Locations extends Backbone.Collection {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.changeSearchParams = this.changeSearchParams.bind(this);
    this.changeParentParams = this.changeParentParams.bind(this);
    this.updateScope = this.updateScope.bind(this);
    this.flattened = this.flattened.bind(this);
    this.currentScope = this.currentScope.bind(this);
    this.scoped = this.scoped.bind(this);
  }

  initialize() {
    return this.on("reset", () => this.changeParentParams());
  }

  changeSearchParams(searchParams = {}, parentParams) {
    this.searchParams = searchParams;
    this.parentParams = parentParams;
    const { lat, lng } = this.searchParams;
    if (lat && lng) {
      this.searchParams.googleLatLng = new google.maps.LatLng(lat, lng);
    }
    return this.updateScope();
  }

  changeParentParams(parentParams = null) {
    this.parentParams = parentParams;
    return this.updateScope();
  }

  updateScope() {
    this.currentParent = this.parentParams ? this.findParent(this.parentParams) : null;

    this.searchScope = this.filter((location) => location.isWithinDistance());

    // Find closest
    if (this.searchParams.lat && this.searchParams.lng && !this.searchParams.range) {
      this.searchScope = this.filter((location) => location.hasAddress());
      this.searchScope = _.sortBy(this.searchScope, (location) => location.distance());
      this.searchScope = [this.searchScope[0]];
    }

    return this.trigger("changeScope");
  }

  flattened() {
    const withAddresses = this.scoped(this.searchScope || []).filter(
      (location) => location.isWithinDistance() && location.hasAddress(),
    );

    if (withAddresses.length <= 5 && withAddresses.length >= 1) {
      return withAddresses;
    }
  }

  currentScope() {
    let flattened;
    if (!this.currentParent) {
      flattened = this.flattened();
    }

    if (flattened) {
      return new Sparkle.LocationBrowser.Collections.Locations(flattened);
    } else {
      return new Sparkle.LocationBrowser.Collections.Locations(
        this.filter((location) => {
          const locationParentId = location.get("parent_id") || null;
          const currentParentId = (this.currentParent != null ? this.currentParent.id : undefined) || null;
          return currentParentId === locationParentId && location.isWithinDistance();
        }),
      );
    }
  }

  // Finds the location `parentParams` names. A url is compared without its locale prefix, since the routes
  // name a location by its bare path and its own url can carry the page's locale.
  findParent(parentParams) {
    if (parentParams.url == null) {
      return this.findWhere(parentParams);
    }

    const url = Locations.barePath(parentParams.url);
    return this.find((location) => Locations.barePath(location.get("url")) === url);
  }

  // Returns `url` without a leading locale segment: "/es/locations/main-campus" → "/locations/main-campus".
  static barePath(url) {
    if (typeof url !== "string") {
      return url;
    }

    const available = window.SparkleConfig?.locales?.available ?? [];
    const segment = url.split("/")[1];

    return available.includes(segment) ? url.slice(segment.length + 1) || "/" : url;
  }

  scoped(locations) {
    if (this.searchScope) {
      return _.intersection(this.searchScope, locations);
    } else {
      return locations;
    }
  }
};
Sparkle.LocationBrowser.Collections.Locations.prototype.model = Sparkle.LocationBrowser.Models.Location;
Sparkle.LocationBrowser.Collections.Locations.prototype.searchParams = {};

Sparkle.LocationBrowser.Collections.Locations.prototype.url = window.Sparkle.apiHost
  ? window.Sparkle.apiHost + window.SparkleConfig.routes.embed.locationsApiBrowser
  : undefined;
